import { render, staticRenderFns } from "./team-list-table.vue?vue&type=template&id=55539220&"
import script from "./team-list-table.vue?vue&type=script&lang=js&"
export * from "./team-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports